import styled from 'styled-components';
import { buttonMixin, colorMixin, sizeMixin } from './ButtonMixins';
import { p4Tokens } from '../../../styles/themes/default/p4FluentTheme';

export const CardLinkButton = styled.div`
  ${buttonMixin} ${sizeMixin} ${(props: any) => colorMixin(props, 'link')};
  text-align: right;
  flex-basis: 40px;
  border: none;
  text-transform: none;
  font-size: 14px;
  padding: 0;
  margin: 0;
  color: ${p4Tokens.fieldLinkForeground};
  &:hover {
    color: ${p4Tokens.fieldLinkHoverForeground};
    text-decoration: underline;
  }
`;
